import dayjs from 'dayjs';
import Cookies from 'universal-cookie';

const cookies = new Cookies(null, {
  path: '/',
  domain: import.meta.env.VITE_COOKIE_DOMAIN,
  expires: dayjs().add(30, 'days').toDate(),
});

export default cookies;
